import React from "react";
import { Box, IconButton, Tooltip } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";

const GridListadoEditable = ({
  rows,
  columnas,
  columnasEditables = [],
  columnasAlineadasDerecha = [],
  onEditarClick,
  onEliminarClick,
  pageSize = 10,
  permitirOrdenarColumnas = "No",
  onRowEditStop,
  processRowUpdate,
  iconoEditar = "Si",
  iconoBorrar = "Si",
  mostrar_check = "No",
  onSelectionModelChange,

  getRowClassName,  // 👈 añadido
  sx,               // 👈 añadido
}) => {
  const renderIconButton = (title, onClick, Icon) => (params) => (
    <Tooltip title={title}>
      <IconButton onClick={() => onClick?.(params.row)}>
        <Icon fontSize="small" />
      </IconButton>
    </Tooltip>
  );

  const extraColumns = [];

  if (iconoEditar !== "No") {
    extraColumns.push({
      field: "acciones",
      headerName: "",
      sortable: false,
      filterable: false,
      width: 60,
      renderCell: renderIconButton("Editar", onEditarClick, EditIcon),
    });
  }

  if (iconoBorrar !== "No") {
    extraColumns.push({
      field: "borrar",
      headerName: "",
      sortable: false,
      filterable: false,
      width: 60,
      renderCell: renderIconButton("Eliminar", onEliminarClick, DeleteIcon),
    });
  }

  const updatedColumns = [
    ...extraColumns,
    ...columnas.map((col) => ({
      ...col,
      editable: columnasEditables.includes(col.field),
      sortable: permitirOrdenarColumnas === "Si",
      align: columnasAlineadasDerecha.includes(col.field) ? "right" : "left",
      headerAlign: columnasAlineadasDerecha.includes(col.field) ? "right" : "left",
    })),
  ];

  return (
    <Box sx={{ width: "100%", overflowX: "auto" }}>
      <DataGrid
        rows={rows}
        columns={updatedColumns}
        localeText={{
          noRowsLabel: "Sin registros",
          footerRowSelected: (count) =>
            count === 1 ? "1 fila seleccionada" : `${count} filas seleccionadas`,
        }}
        pageSizeOptions={[25, 50, 100]}
        initialState={{
          pagination: {
            paginationModel: { pageSize: 100, page: 0 },
          },
        }}
        disableSelectionOnClick
        experimentalFeatures={{ newEditingApi: true }}
        processRowUpdate={processRowUpdate}
        onRowEditStop={onRowEditStop}
        // 👇 solo activa los checks si el prop está en "Si"
        checkboxSelection={mostrar_check === "Si"}
        getRowClassName={getRowClassName}   // 👈 ahora sí

        sx={{
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: "#ffffff",
            color: "#000000",
            fontWeight: "bold",
            fontSize: "14px",
          },
          "& .MuiDataGrid-cell": {
            borderBottom: "1px solid #e0e0e0",
          },
          "& .MuiDataGrid-footerContainer": {
            backgroundColor: "#f5f5f5",
          },
          ...sx, // 👈 aquí mezclamos lo que venga de fuera
        }}

        // checkboxSelection={mostrar_check === "Si"}
        onRowSelectionModelChange={(newSelection) => {
          if (typeof onSelectionModelChange === "function") {
            onSelectionModelChange(newSelection);
          }
        }}

      />
    </Box>
  );
};

export default GridListadoEditable;
